import styled from '@emotion/styled/macro';
import ReactSelect from 'react-select';

export const Select = styled(ReactSelect)`
  flex: 1;
  position: ${(props) => props.position};

  .rs__value-container {
    .rs__single-value {
      color: ${({ theme }) => theme.colors.primary};
    }
    .rs__input-container {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .rs__control {
    background-color: ${({ theme }) => theme.input.background};
    border: 0;
    box-shadow: ${({ isInvalid, theme }) =>
      isInvalid ? theme.input.boxShadowError : theme.input.boxShadow};
    &:hover {
      box-shadow: ${({ theme }) => theme.input.boxShadowHovered};
    }
    &--is-focused {
      outline: none;
      box-shadow: ${({ theme }) => theme.input.boxShadowFocused};
    }
    &--is-disabled {
      opacity: 40%;
    }
  }
  .rs__menu {
    background-color: ${({ theme }) => theme.bgColors.surfaceOverlay};
    .rs__option {
      cursor: pointer;
      background-color: ${({ theme }) => theme.bgColors.surfaceOverlay};
      color: ${({ theme }) => theme.colors.primary};
      &--is-focused {
        background-color: ${({ theme }) => theme.input.darkerHovered};
      }
    }
  }
`;
